import { jsx as _jsx } from "react/jsx-runtime";
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import classNames from 'pricing-pages-ui/utils/classNames';

const LoadingMerchCardAuthedCTAs = props => {
  const {
    containterStyle = {},
    className,
    numPurchaseMotions,
    maxPurchaseMotionsOnPage,
    ctaStyles = {}
  } = props;
  const loadingButtonCount = Math.min(numPurchaseMotions, maxPurchaseMotionsOnPage);
  const loadingButtons = [];

  for (let i = 0; i < loadingButtonCount; i++) {
    loadingButtons.push( /*#__PURE__*/_jsx(UILoadingButton, {
      use: "primary",
      loading: true,
      className: classNames((loadingButtonCount === 1 || i < loadingButtonCount - 1) && 'm-bottom-2', 'm-x-0'),
      style: ctaStyles,
      children: "Loading"
    }, i));
  }

  return /*#__PURE__*/_jsx("div", {
    style: Object.assign({}, containterStyle),
    className: classNames(className, 'flex-column align-center'),
    children: loadingButtons
  });
};

export default LoadingMerchCardAuthedCTAs;